<template>
    <div>
        <h3 class="search-results__filters-h3">Refine your search</h3>
        <img src="/images/used/close-icon.svg" class="search-results__close-icon" alt="Close filters" @click="closeFilters" />
        <form action="/used-vehicles/results" method="get" id="used-vehicles-form" class="rd-card rd-card--border-top rd-card--less-padding search-results__filters-card">
            <div class="search-results__filters-section">
                <div class="redesign-checkbox__label redesign-checkbox__label--grid">
                    <input type="checkbox" id="exclusive-offers" name="exclusive-offers" class="redesign-checkbox__span" v-model="toggleExclusiveOffers"/>

                    <label class="redesign-checkbox__label" for="exclusive-offers" :checked="toggleExclusiveOffers">
                        <span class="redesign-checkbox__label-text">Show Exclusive Offers</span>
                    </label>
                </div>
            </div>

            <hr class="search-results__filters-hr" />

            <div class="search-results__filters-section">
                <div class="search-results__filters-section-label" @click="sectionVisible['location'] = !sectionVisible['location']">
                    <h4 class="search-results__filters-section-title">Location</h4>
                    <img src="/images/used/filters-arrow.svg" class="search-results__filters-section-arrow" :class="{ 'search-results__filters-section-arrow--open': sectionVisible['location'] }" />
                </div>
                <div class="search-results__filters-section-content" :class="{ 'search-results__filters-section-content--hidden': !sectionVisible['location'] }">
                    <div class="form-grid form-grid--xs-1-column">
                        <div class="form-grid__col-span-2 form-grid__col--xs-full-width" v-show="!haveDealerLanding">
                            <NonMaterialCustomerLocation placeholder="Postcode/Town" :show-label="false" :input-nullable="true" v-on:changed="filterDealers" />
                        </div>

                        <div class="form-grid__col-span-2 form-grid__col--xs-full-width" v-show="!haveDealerLanding">
                            <div class="form-element__container">
                                <label class="form-element__label" :class="{'form-element__label--active': distance}" for="distance">Distance</label>
                                <select class="form-element__input" :disabled="loading" v-model="distance">
                                    <option v-for="option in distances" :value="option" :key="option">{{ formatDistance(option) }}</option>
                                </select>
                            </div>
                        </div>

                        <div class="form-grid__col-span-2 form-grid__col--xs-full-width" v-if="haveDealerLanding">
                            <div class="form-element__container">
                                <p>Viewing stock at {{ dealerLandingPage.short_name }}</p>
                                <button class="btn btn--fake-link" @click="clearDealerLandingPage">Clear</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <hr class="search-results__filters-hr" />

            <UsedSearchResultsFilter title="Make" options-key="manufacturer" />

            <hr class="search-results__filters-hr" />

            <UsedSearchResultsFilter title="Model" options-key="model" :enableSearch="true"/>

            <hr class="search-results__filters-hr" />

            <UsedSearchResultsFilter title="Fuel type" options-key="fuelType" />

            <hr class="search-results__filters-hr" />

            <div class="search-results__filters-section">
                <div class="search-results__filters-section-label" @click="sectionVisible['price'] = !sectionVisible['price']">
                    <h4 class="search-results__filters-section-title">Price</h4>
                    <img src="/images/used/filters-arrow.svg" class="search-results__filters-section-arrow" :class="{ 'search-results__filters-section-arrow--open': sectionVisible['price'] }" />
                </div>
                <div class="search-results__filters-section-content" :class="{ 'search-results__filters-section-content--hidden': !sectionVisible['price'] }">
                    <div class="search-results__input-pills">
                        <div class="search-results__input-pill">
                            <input type="radio" v-model="paymentSearch"
                                :id="`${fullFormIdentifier}-price`" :value="0" autocomplete="off" />
                            <label :for="`${fullFormIdentifier}-price`">
                                <span>Cash</span>
                            </label>
                        </div>
                        <div class="search-results__input-pill">
                            <input type="radio" v-model="paymentSearch"
                                :id="`${fullFormIdentifier}-monthly`" :value="1" autocomplete="off" />
                            <label :for="`${fullFormIdentifier}-monthly`">
                                <span>Finance</span>
                            </label>
                        </div>
                    </div>

                    <div v-show="paymentSearch == 0" class="search-results__filters-slider-container">
                        <label class="search-results__slider-label">
                            Price
                        </label>
                        <div ref="priceRange"></div>
                        <div class="search-results__slider-values">
                            <div class="search-results__slider-value">{{ displayMinPriceFormatted }}</div>
                            <div class="search-results__slider-value">{{ displayMaxPriceFormatted }}</div>
                        </div>
                    </div>
                    <div v-show="paymentSearch == 1" class="search-results__filters-slider-container form-grid form-grid--xs-1-column">
                        <div class="form-grid__col-span-2 form-grid__col--xs-full-width">
                            <div class="form-element__container">
                                <label class="form-element__label form-element__label--active" for="depositInput">Deposit</label>
                                <input type="text" v-currency="{ currency: 'GBP', locale: 'en' }" id="depositInput" ref="depositInput"
                                    v-model="depositInput" class="form-element__input" />
                            </div>
                        </div>

                        <div class="form-grid__col-span-2 form-grid__col--xs-full-width">
                            <div class="form-element__container">
                                <label class="form-element__label form-element__label--active" for="termInput">Choose the length of your
                                    contract</label>

                                <select class="form-element__input" id="termInput" :disabled="loading" v-model="term">
                                    <option disabled>Term</option>
                                    <option value="36">36 months</option>
                                    <option value="42">42 months</option>
                                    <option value="48">48 months</option>
                                </select>
                            </div>
                        </div>

                        <div class="form-grid__col-span-2 form-grid__col--xs-full-width">
                            <div class="form-element__container">
                                <label class="form-element__label form-element__label--active" for="annualMileage">Choose the length of your
                                    contract</label>

                                <select class="form-element__input" id="annualMileage" :disabled="loading" v-model="annualMileage">
                                    <option disabled>Annual Mileage</option>
                                    <option value="6000">6,000 miles per annum</option>
                                    <option value="10000">10,000 miles per annum</option>
                                    <option value="15000">15,000 miles per annum</option>
                                    <option value="20000">20,000 miles per annum</option>
                                </select>
                            </div>
                        </div>


                        <!-- <div class="finance-calculator__form-group form-group">
                            <label class="finance-calculator__label" for="pcp-mileage-select">Choose an annual
                                milage</label>
                            <select name="mileage" class="form-control" v-model.number="mileage">
                                <option v-for="mileageOption in selectedFinance.mileage" :key="mileageOption"
                                    :value="mileageOption">{{ mileageOption }} miles</option>
                            </select>
                        </div> -->
                        <div class="form-grid__col-span-2 form-grid__col--xs-full-width">
                            <label class="search-results__slider-label">
                                Monthly Payment
                            </label>
                            <div ref="monthlyPaymentRange"></div>
                            <div class="search-results__slider-values">
                                <div class="search-results__slider-value">{{ displayMinPaymentFormatted }}</div>
                                <div class="search-results__slider-value">{{ displayMaxPaymentFormatted }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <hr class="search-results__filters-hr" />

            <UsedSearchResultsFilter title="Body style" options-key="body" :has-count="true" />

            <hr class="search-results__filters-hr" />

            <UsedSearchResultsFilter title="Age" options-key="age" type="select" :has-count="false" :format-function="function(age) {
                if (age == 1) {
                    return 'Up to ' + age + ' year old';
                }

                return 'Up to ' + age + ' years old';
            }" />

            <hr class="search-results__filters-hr" />

            <UsedSearchResultsFilter title="Mileage" options-key="mileage" :has-count="false" type="select" :format-function="function(mileage) {
                return 'Up to ' + number_format(mileage) + ' miles';
            }" />

            <hr class="search-results__filters-hr" />

            <UsedSearchResultsColourFilter />

            <hr class="search-results__filters-hr" />

            <UsedSearchResultsFilter title="Vehicle type" options-key="carOrVan" :has-count="false" :format-function="function(carOrVan) {
                if (carOrVan == 'commercial') {
                    return 'Van';
                }
                return 'Car';
            }" />

            <hr class="search-results__filters-hr" />

            <UsedSearchResultsFilter title="Transmission" options-key="transmission" />

            <hr class="search-results__filters-hr" />

            <UsedSearchResultsFilter title="Annual tax" options-key="annual_tax" :has-count="false" type="select" :format-function="function(annualTax) {
                if (annualTax == 0) {
                    return '£0 Tax';
                }
                return 'Up to £' + number_format(annualTax) + ' Tax';
            }" />

            <hr class="search-results__filters-hr" />

            <UsedSearchResultsFilter title="CO2 emissions" options-key="emissions" :has-count="false" type="select" :format-function="function(emissions) {
                if (emissions == 0) {
                    return '0 g/km CO2';
                }
                return 'Up to ' + emissions + ' g/km CO2';
            }" />

            <hr class="search-results__filters-hr" />

            <UsedSearchResultsFilter title="Registration" placeholder="Enter reg (if known)" options-key="registration" :has-count="false" type="text" />

            <hr class="search-results__filters-hr" />

            <UsedSearchResultsFilter title="Keywords" placeholder="Enter any keyword" options-key="keywords" :has-count="false" type="text" />

            <hr class="search-results__filters-hr" />

            <div class="redesign-checkbox__label redesign-checkbox__label--grid">
                <input type="checkbox" id="hide-reserved" name="hide-reserved" class="redesign-checkbox__span" v-model="hideReserved"/>

                <label class="redesign-checkbox__label" for="hide-reserved" :checked="hideReserved">
                    <span class="redesign-checkbox__label-text">Hide Reserved Vehicles</span>
                </label>
            </div>

            <hr class="search-results__filters-hr" />

            <div class="redesign-checkbox__label redesign-checkbox__label--grid">
                <input type="checkbox" id="nearly-new" name="nearly-new" class="redesign-checkbox__span" v-model="nearlyNew"/>

                <label class="redesign-checkbox__label" for="nearly-new" :checked="nearlyNew">
                    <span class="redesign-checkbox__label-text">Nearly New</span>
                </label>
            </div>

            <hr class="search-results__filters-hr" />

            <button type="button" @click="scrollToResults" class="btn btn--primary btn--full-width search-results__filters-btn">Search <span class="offcanvas-search__count-num">{{ countFormatted }}</span> used cars</button>
            <button type="button" @click="resetForm" class="btn btn--fake-link btn--full-width search-results__filters-reset-btn">Reset search criteria</button>
        </form>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import twoWayComputedProperties from "../api/used-search-options/TwoWayComputedProperties";
import NonMaterialCustomerLocation from '../components/Forms/Non-Material/CustomerLocation.vue';
import UsedSearchResultsFilter from '../components/UsedSearchResultsFilter.vue';
import UsedSearchResultsColourFilter from '../components/UsedSearchResultsColourFilter.vue';
import numberFormat from '../api/NumberFormat';
import debounce from 'lodash/debounce';
import { CurrencyDirective, getValue } from "vue-currency-input";
const noUiSlider = require('nouislider');

export default {
    components: {
        NonMaterialCustomerLocation,
        UsedSearchResultsFilter,
        UsedSearchResultsColourFilter,
    },
    directives: {
        currency: CurrencyDirective,
    },
    data() {
        return {
            sectionVisible: {
                location: true,
                price: true,
            },
            displayMinPayment: null,
            displayMaxPayment: null,
            displayMinPrice: null,
            displayMaxPrice: null,
            priceSlider: null,
            depositInput: 2315,
        };
    },
    watch: {
        depositInput: {
            deep: false,
            immediate: false,
            handler: function (val) {
                if (typeof val == "string") {
                    if (this.$refs.depositInput) {
                        val = getValue(this.$refs.depositInput);
                    } else {
                        val = parseFloat(val);
                    }
                }
                if (typeof val == "undefined" || val === null) {
                    val = 0;
                }
                if (val < 0) {
                    val = 0;
                }
                this.$store.dispatch('UsedSearchOptions/setUserOptionsByPushingRoute', {
                    deposit: val,
                });
            },
        },
        minPayment: function (val, oldVal) {
            this.paymentSearchSlider.updateOptions({
                range: {
                    'min': [ this.minPayment ],
                    'max': [ this.maxPayment ]
                },
            });
        },
        maxPayment: function (val, oldVal) {
            this.paymentSearchSlider.updateOptions({
                range: {
                    'min': [ this.minPayment ],
                    'max': [ this.maxPayment ]
                },
            });
        },
        minPrice: function (val, oldVal) {
            this.priceSlider.updateOptions({
                range: {
                    'min': [ this.minPrice ],
                    'max': [ this.maxPrice ]
                },
            });
        },
        maxPrice: function (val, oldVal) {
            this.priceSlider.updateOptions({
                range: {
                    'min': [ this.minPrice ],
                    'max': [ this.maxPrice ]
                },
            });
        },
    },
    computed: {
        ...mapGetters({
            manufacturers: 'UsedSearchOptions/manufacturers',
            userOptions: 'UsedSearchOptions/userOptions',
            loading: 'UsedSearchOptions/loading',
            distances: 'UsedSearchOptions/distances',
            minPrice: 'UsedSearchOptions/minPrice',
            maxPrice: 'UsedSearchOptions/maxPrice',
            minPayment: 'UsedSearchOptions/minPayment',
            maxPayment: 'UsedSearchOptions/maxPayment',
            dealerLandingPage: 'UsedSearchOptions/dealerLandingPage',
        }),
        ...twoWayComputedProperties([
                // 'paymentRange',
                // 'deposit',
                'term',
                'annualMileage',
                // 'model',
                // 'maxPrice',
                // 'age',
                // 'fuelType',
                // 'numDoors',
                // 'body',
                // 'mileage',
                // 'transmission',
                // 'colour',
                // 'engineSize',
                // 'photo',
                // 'carOrVan',
                // 'trim',
                // 'programme',
                'nearlyNew',
            ],
            'UsedSearchOptions/setUserOptionsByPushingRoute'
        ),
        countFormatted: {
            get() {
                return numberFormat(this.$store.state.UsedSearchOptions.animatedCount);
            },
        },
        fullFormIdentifier() {
            return 'search-by-' + this._uid;
        },
        paymentSearch: {
            get() {
                return (this.userOptions.paymentSearch == "1" || this.userOptions.paymentSearch == 1) ? 1 : 0;
            },
            set (value) {
                this.$store.dispatch('UsedSearchOptions/setUserOptionsByPushingRoute', {
                    paymentSearch: (value) ? 1 : 0,
                });
            }
        },
        hideReserved: {
            get() {
                return this.userOptions.hideReserved;
            },
            set (value) {
                this.$store.dispatch('UsedSearchOptions/setUserOptionsByPushingRoute', {
                    hideReserved: value,
                });
            }
        },
        toggleExclusiveOffers: {
            get() {
                return this.userOptions.exclusiveOffers;
            },
            set (value) {
                this.$store.dispatch('UsedSearchOptions/setUserOptionsByPushingRoute', {
                    exclusiveOffers: value,
                });
            }
        },
        distance: {
            get() {
                return this.userOptions.distance;
            },
            set (value) {
                this.$store.commit('UsedSearchOptions/setUserOptions', {
                    distance: value
                });
                this.filterDealers(value);
            }
        },
        minSelectedPrice: {
            get() {
                const minPrice = new Number(this.userOptions.minPrice);
                if (isNaN(minPrice)) {
                    return this.$store.state.UsedSearchOptions.options.minPrice;
                }
                return minPrice;
            },
            set (value) {
                if (value > this.maxSelectedPrice) {
                    this.minSelectedPrice = this.maxSelectedPrice;
                    return;
                }
                this.$store.dispatch('UsedSearchOptions/setUserOptionsByPushingRoute', {
                    minPrice: value,
                });
            }
        },
        maxSelectedPrice: {
            get() {
                const maxPrice = new Number(this.userOptions.maxPrice);
                if (isNaN(maxPrice)) {
                    return this.$store.state.UsedSearchOptions.options.maxPrice;
                }
                return maxPrice;
            },
            set (value) {
                this.$store.dispatch('UsedSearchOptions/setUserOptionsByPushingRoute', {
                    maxPrice: value,
                });
            }
        },
        minSelectedPayment: {
            get() {
                const minPayment = new Number(this.userOptions.minPayment);
                if (isNaN(minPayment)) {
                    return this.$store.state.UsedSearchOptions.options.minPayment;
                }
                return minPayment;
            },
            set (value) {
                if (value > this.maxSelectedPrice) {
                    this.minSelectedPrice = this.maxSelectedPrice;
                    return;
                }
                this.$store.dispatch('UsedSearchOptions/setUserOptionsByPushingRoute', {
                    minPayment: value,
                });
            }
        },
        maxSelectedPayment: {
            get() {
                const maxPayment = new Number(this.userOptions.maxPayment);
                if (isNaN(maxPayment)) {
                    return this.$store.state.UsedSearchOptions.options.maxPayment;
                }
                return maxPayment;
            },
            set (value) {
                this.$store.dispatch('UsedSearchOptions/setUserOptionsByPushingRoute', {
                    maxPayment: value,
                });
            }
        },
        displayMinPaymentFormatted() {
            return '£' + numberFormat(this.displayMinPayment, 0);
        },
        displayMaxPaymentFormatted() {
            return '£' + numberFormat(this.displayMaxPayment, 0);
        },
        displayMinPriceFormatted() {
            return '£' + numberFormat(this.displayMinPrice, 0);
        },
        displayMaxPriceFormatted() {
            return '£' + numberFormat(this.displayMaxPrice, 0);
        },
        haveDealerLanding() {
            if (typeof this.dealerLandingPage == 'undefined') {
                return false;
            }
            if (this.dealerLandingPage == null) {
                return false;
            }
            return true;
        }
    },
    methods: {
        closeFilters() {
            this.$emit('close-filters');
        },

        scrollToResults() {
            this.$emit('scroll-to-results');
        },

        formatDistance(distance) {
            if (distance == -1) {
                return 'Any distance';
            }
            return 'Within ' + numberFormat(distance, 0) + ' miles';
        },

        number_format(num) {
            return numberFormat(num);
        },

        resetForm: debounce(function() {
            this.$store.dispatch('UsedSearchOptions/resetUserOptionsByPushingRoute');
        }, 1000, {leading:true}),

        filterDealers() {
            this.$store.dispatch('UsedSearchOptions/locationUpdated', {
                triggerOptionsUpdate: true,
                updateViaRoute: true
            });
        },

        initPaymentSearchSlider() {
            let min = 0;
            if (typeof this.$store.state.UsedSearchOptions.options.monthlyPayments.min != 'undefined') {
                min = parseInt(this.$store.state.UsedSearchOptions.options.monthlyPayments.min);
            }
            let max = 2000;
            if (typeof this.$store.state.UsedSearchOptions.options.monthlyPayments.max != 'undefined') {
                max = parseInt(this.$store.state.UsedSearchOptions.options.monthlyPayments.max);
            }
            const start = this.minSelectedPayment;
            this.displayMinPayment = this.minSelectedPayment;
            const finish = this.maxSelectedPayment;
            this.displayMaxPayment = this.maxSelectedPayment;

            this.paymentSearchSlider = noUiSlider.create(this.$refs['monthlyPaymentRange'], {
                start: [ start , finish ],
                behaviour: 'drag-tap',
                connect: true,
                range: {
                    'min': [ min ],
                    'max': [ max ]
                },
                step: 5,
            });

            this.paymentSearchSlider.on('update', (data) => {
                this.displayMinPayment = data[0];
                this.displayMaxPayment = data[1];
            });

            this.paymentSearchSlider.on('change', (data) => {
                if (data[0] != this.minPayment || data[1] != this.maxPayment) {
                    this.$store.dispatch('UsedSearchOptions/setUserOptionsByPushingRoute', {
                        minPayment: parseInt(data[0]),
                        maxPayment: parseInt(data[1]),
                    });
                }
            });
        },

        initPriceSearchSlider() {
            let min = this.$store.state.UsedSearchOptions.options.minPrice;
            if (min == null) {
                min = 0
            }
            let max = this.$store.state.UsedSearchOptions.options.maxPrice;
            if (max == null) {
                max = 100000;
            }
            let start = this.minSelectedPrice;
            this.displayMinPrice = this.minSelectedPrice;
            let finish = this.maxSelectedPrice;
            if (finish == 0) {
                finish = max;
            }
            this.displayMaxPrice = this.maxSelectedPrice;

            this.priceSlider = noUiSlider.create(this.$refs['priceRange'], {
                start: [ start , finish ],
                behaviour: 'drag-tap',
                connect: true,
                range: {
                    'min': [ min ],
                    'max': [ max ]
                },
                step: 250,
                // pips: {
                //     mode: 'positions',
                //     values: [0, 100],
                //     density: 100000,
                //     format: wNumb({
                //         decimals: 0,
                //         prefix: '£',
                //     })
                // }
            });

            this.priceSlider.on('update', (data) => {
                this.displayMinPrice = data[0];
                this.displayMaxPrice = data[1];
            });
            this.priceSlider.on('change', (data) => {
                if (data[0] != this.minSelectedPrice || data[1] != this.maxSelectedPrice) {
                    this.$store.dispatch('UsedSearchOptions/setUserOptionsByPushingRoute', {
                        minPrice: parseInt(data[0]),
                        maxPrice: parseInt(data[1]),
                    });
                }
            });
        },
        clearDealerLandingPage() {
            this.$store.commit('UsedSearchOptions/clearDealerLandingPageData');
            this.$store.dispatch('UsedSearchOptions/locationUpdated', {triggerOptionsUpdate: true, updateViaRoute: true});
            // this.$store.dispatch('UsedSearchOptions/setUserOptionsByPushingRoute', {});
        }
    },

    mounted() {
        this.initPriceSearchSlider();
        this.initPaymentSearchSlider();
    },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/used-vue/components/UsedSearchResultsFilters.vue